import utils from 'lib/utils';

export default class LearnerProfileService {
  static initialize(profile) {
    this.data = profile;
  }

  static get(key) {
    if (this.data) {
      return this.data[key];
    }
  }

  static getByDotString(dotString) {
    return utils.getByDotString(dotString, LearnerProfileService.get.bind(this));
  }
}
